import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import _ from 'lodash';
import {List} from 'semantic-ui-react';
import {
  checkForValidationErrors,
  evalSectionStatus,
  shouldDisplaySection,
} from 'common/utils';
import {shouldDisplay} from 'componentLibrary/layout/ShowHide';

export class ReviewErrors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      sectionErrors: [],
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {data, componentsToCheck} = nextProps;
    prevState.errors = checkForValidationErrors(data, _.keys(componentsToCheck));
    return prevState;
  }

  componentDidMount() {
    const {saveEntitySessionData = () => {}} = this.props;

    const sectionErrors = this.validateSections();

    this.setState({sectionErrors});

    saveEntitySessionData(
      'data.payload.reviewPanel.reviewErrors',
      sectionErrors.length > 0
    );
  }

  componentDidUpdate() {
    const {saveEntitySessionData} = this.props;

    const sectionErrors = this.validateSections();

    if (!_.isEqual(sectionErrors, this.state.sectionErrors)) {
      this.setState({sectionErrors});
      saveEntitySessionData(
        'data.payload.reviewPanel.reviewErrors',
        sectionErrors.length > 0
      );
    }
  }

  validateSections = () => {
    const {
      sectionsToCheck,
      configSections,
      isChildSectionsToCheck,
      allValidationErrors,
    } = this.props;
    let allConfigSections = [];
    if (isChildSectionsToCheck) {
      _.forEach(configSections, (configSection) => {
        if (
          configSection.navToChildren &&
          _.isEqual(configSection.navToChildren, true) &&
          _.has(configSection, 'contents')
        ) {
          let nestedContents = _.get(configSection, 'contents');
          _.forEach(nestedContents, (nestedContent) => {
            allConfigSections.push(nestedContent);
          });
        } else {
          allConfigSections.push(configSection);
        }
      });
    } else {
      allConfigSections = configSections;
    }
    const sections = _.filter(allConfigSections, (section) =>
      shouldDisplaySection(section, this.props, shouldDisplay)
    );
    const matchingSections = _.filter(
      sections,
      (section) => _.filter(sectionsToCheck, (s) => s.name == section.title).length > 0
    );
    const sectionsWithErrors = _.filter(
      matchingSections,
      (section) => evalSectionStatus(section, allValidationErrors) !== 'complete'
    );
    const sectionErrors = _.map(sectionsWithErrors, (section) => ({
      ...section,
      link: _.filter(sectionsToCheck, (s) => s.name === section.title)[0].link,
      href: _.filter(sectionsToCheck, (s) => s.name === section.title)[0].href,
    }));
    return sectionErrors;
  };

  render() {
    const {
      setCurrentFieldList,
      componentsToCheck,
      noErrorsMessage,
      errorsMessage,
    } = this.props;
    const {errors, sectionErrors} = this.state;

    if (errors.length > 0 || sectionErrors.length > 0) {
      const errorsToDisplay = _.uniqWith(
        _.map(errors, (e) => componentsToCheck[e]),
        _.isEqual
      );
      return (
        <React.Fragment>
          {errorsMessage}
          <List as="ul">
            {_.map(sectionErrors, (section) => (
              <List.Item as="li" key={section.title}>
                <a
                  href={`#${section.href ? section.href : section.title}`}
                  onClick={() => setCurrentFieldList(section.link)}
                  title={section.title}
                >
                  {section.title}
                </a>
              </List.Item>
            ))}
          </List>
          <List as="ul">
            {_.map(errorsToDisplay, (error) => (
              <List.Item as="li" key={error.name}>
                <a
                  href={`#${error.href ? error.href : error.name}`}
                  onClick={() => setCurrentFieldList(error.link)}
                  title={error.name}
                >
                  {error.name}
                </a>
              </List.Item>
            ))}
          </List>
        </React.Fragment>
      );
    }
    return noErrorsMessage;
  }
}

export const mapStateToProps = (state, componentProps) => {
  let props = {};

  if (componentProps.navDependencies) {
    _.forEach(componentProps.navDependencies, (dep) => {
      props[dep.name] = _.get(state.dynamicComponent, dep.path);
    });
  }
  return props;
};

export default connect(mapStateToProps)(connectDynamic(ReviewErrors));
